import { createContext, use, useCallback, useMemo } from 'react';
import { type Banner } from '@sr/types';
import { useBanners } from './useBanner';

const BannerContext = createContext<{
  getBannerForScope: (scope: string) => Banner[];
  error: boolean;
  isLoading: boolean;
} | null>(null);

export const BannerProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: banners, isLoading, error } = useBanners();

  const getBannerForScope = useCallback(
    (scope: string) => {
      return banners?.filter((banner) => banner.scope === scope) ?? [];
    },
    [banners],
  );
  const contextValue = useMemo(
    () => ({
      error: !!error,
      getBannerForScope,
      isLoading,
    }),
    [error, getBannerForScope, isLoading],
  );

  return <BannerContext value={contextValue}>{children}</BannerContext>;
};

export const useBannersV2 = () => {
  const context = use(BannerContext);

  if (!context) {
    throw new Error('useBanners must be used within a BannerProvider');
  }

  return context;
};
